// Without S3 the backend hands out host-relative file paths (/media/receipts/x.png). Those live on the
// API host, not on the PWA's own origin, so resolve them against it; absolute (S3) URLs pass through.
export const backendUrl = (url: string) => new URL(url, import.meta.env.VITE_API_URL || window.location.origin).toString()
